import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { XMark } from "assets/icons";

const NotificationDrawer = ({ isOpen, onClose, children }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 flex bg-black dark:bg-[#1467B0B5] bg-opacity-50 justify-end items-end z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}>
          <motion.div
            className="absolute right-0 pt-6 pb-12 overflow-auto bg-white dark:bg-slate-950 h-full w-full sm:w-[500px] flex flex-col items-center gap-4 sm:rounded-l-lg no-scrollbar"
            initial={{ x: "100%" }}
            animate={{ x: "0%" }}
            exit={{ x: "100%" }}
            transition={{
              type: "just",
              stiffness: 300,
              damping: 20,
              duration: 0.3,
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}>
            <div className="w-full px-6 flex justify-end items-center">
              <div
                className="hover:cursor-pointer"
                onClick={onClose}>
                <XMark className="dark:text-white" />
              </div>
            </div>
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NotificationDrawer;
